import React from 'react'

import bagIcon from 'assets/landing-images/bag.png'
import bagIcon2x from 'assets/landing-images/bag@2x.png'
import discordIcon from 'assets/landing-images/discord.svg'
import swapIcon from 'assets/landing-images/swap.png'
import swapIcon2x from 'assets/landing-images/swap@2x.png'
import telegramIcon from 'assets/landing-images/telegram.svg'

import { ButtonStyled, IconStyled, RouteLink } from './styleds'

export type Variant = 'primary' | 'secondary'
export type Color = 'red' | 'yellow' | 'green' | 'purple' | 'blue'
type Icon = 'swap' | 'bag' | 'telegram' | 'discord'

const icons: Record<Icon, string> = {
  swap: swapIcon,
  bag: bagIcon,
  telegram: telegramIcon,
  discord: discordIcon
}

const icons2x: Partial<Record<Icon, string>> = {
  swap: swapIcon2x,
  bag: bagIcon2x
}

type Props = {
  routeTo?: string
  iconClassName?: string
  routeLinkClassName?: string
  variant?: Variant
  color?: Color
  icon?: Icon
} & React.HTMLProps<HTMLAnchorElement> &
  React.HTMLProps<HTMLButtonElement>

export const Button = ({
  routeTo,
  iconClassName,
  routeLinkClassName,
  variant = 'primary',
  color = 'red',
  icon,
  ...props
}: Props) => {
  const ButtonRoot = ({ tag }: { tag: 'button' | 'a' | 'div' }) => (
    <ButtonStyled
      as={tag}
      href={props.href}
      type="button"
      className={props.className}
      variant={variant}
      color={color}
      disabled={!!props.disabled}
      {...(props as any)}
    >
      {icon && (
        <IconStyled
          srcSet={icons2x[icon] ? `${icons2x[icon]} 2x` : undefined}
          src={icons[icon]}
          alt={icon}
          className={iconClassName}
        />
      )}
      {props.children}
    </ButtonStyled>
  )

  return routeTo ? (
    <RouteLink
      to={routeTo}
      className={routeLinkClassName}
      disabled={!!props.disabled}
      style={{ textDecoration: 'none' }}
    >
      <ButtonRoot tag="div" />
    </RouteLink>
  ) : (
    <ButtonRoot tag={props.href ? 'a' : 'button'} />
  )
}
